import React from 'react'
import Warehouse from '../Warehouse'
import { Link, useLocation, useParams } from 'react-router-dom'
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const WarehouseSpoil = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Warehouse>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/warehouse/spoil/data`} className={` sub-menu-item ${split[4] === 'data'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Data Spoil</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/warehouse/spoil/validasi`} className={` sub-menu-item ${split[4] === 'validasi'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Validasi</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/warehouse/spoil/form`} className={` sub-menu-item ${split[4] === 'form'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Kasir Spoil</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Warehouse>
    )
}

export default WarehouseSpoil
